/**
 * Patient dashboard profile form (Mis Datos).
 *
 * Vanilla module: the form markup is PHP-rendered by
 * template-parts/dashboard/datos.php (it carries its own nonce field), so
 * there is no React mount — we just bind to the form ID and post the
 * FormData to admin-ajax. Message styling uses semantic tokens so both
 * themes render correctly (this file is scanned by Tailwind).
 */

const MSG_BASE = "p-4 rounded-xl text-sm";
const MSG_SUCCESS = `${MSG_BASE} bg-secondary/10 text-secondary-dark`;
const MSG_ERROR = `${MSG_BASE} bg-accent/10 text-accent-dark`;

export function initProfileForm(): void {
  const form = document.getElementById(
    "manosactivas-profile-form",
  ) as HTMLFormElement | null;
  const ajax = window.manosactivasAjax;
  if (!form || !ajax) return;

  const message = document.getElementById("profile-message");
  const submitButton = form.querySelector<HTMLButtonElement>(
    'button[type="submit"]',
  );

  const showMessage = (kind: "success" | "error", text: string) => {
    if (!message) return;
    message.className = kind === "success" ? MSG_SUCCESS : MSG_ERROR;
    message.textContent = text;
  };

  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    const formData = new FormData(form);
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.innerText = "Guardando...";
    }

    try {
      const response = await fetch(ajax.ajaxurl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();

      if (data.success) {
        showMessage("success", "Perfil actualizado correctamente.");
        if (formData.get("new_password")) {
          // Clear both password fields — they must not linger in the DOM.
          for (const name of ["new_password", "current_password"]) {
            const input = form.querySelector<HTMLInputElement>(
              `[name="${name}"]`,
            );
            if (input) input.value = "";
          }
        }
      } else {
        showMessage(
          "error",
          typeof data.data === "string"
            ? data.data
            : "Error al actualizar el perfil.",
        );
      }
    } catch {
      showMessage("error", "Error de conexión.");
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.innerText = "Guardar Cambios";
      }
    }
  });
}
